import { Space, Tooltip } from "antd";
import { BiInfoCircle } from "react-icons/bi";

const InfoCard = ({ icon, label, title, onInfo, infoBtnTooltip }) => {
  return (
    <>
      <Space className="w-1/2 flex justify-start gap-10">
        <div className="flex items-center gap-4">
          <div className="w-[45px] h-[45px] bg-[#A334341A] flex justify-center items-center rounded-full">{icon}</div>
          <p className="text-[#000000] leading-6 text-left text-sm">
            {label}
            <br />
            <strong className="text-xl">{title}</strong>{" "}
          </p>
        </div>
        {onInfo && (
          <div className="flex items-center gap-1 cursor-pointer" onClick={onInfo}>
            <Tooltip title={infoBtnTooltip}>
              <BiInfoCircle className="text-[#A33434]" size={24} />
            </Tooltip>
          </div>
        )}
      </Space>
    </>
  );
};

export default InfoCard;
